<template lang="html">

  <section class="participants">
    <div class="pageHeading">
      <v-container grid-list-md pa-0>
        <v-layout row wrap>
      <v-flex >
      <h2>Participants</h2>
      </v-flex>
      <v-flex xs12 md6 >
        <v-autocomplete v-show="!$isParent"
                v-model="$filterTripID"
                :items="$structuredData.trips"
                @change="selectedResult = null"
                color="black"
                hide-no-data
                hide-selected
                item-text="prettyName"
                item-value="_id"
                label="Limit To Trip ID"
                persistent-hint
                solo
                prepend-icon="mdi-database-search"
                return-object
        ></v-autocomplete>
      </v-flex>
        </v-layout>
      </v-container>
    </div>




    <participant-edit-form v-on:closeDialog="openDialog=false"  v-on:alertUser="(result, message) => {this.$emit('alertUser', result, message); openDialog=false;}" v-bind:dialog="openDialog" v-bind:participant="participantToEdit"></participant-edit-form>

    <v-card elevation="1" style="" >



      <v-toolbar
              color="primary"
              dark
              tabs
      >
        <v-text-field
                class="mx-3"
                flat
                v-model="searchField"
                label="Search"
                prepend-inner-icon="search"
                clearable
                solo-inverted
        ></v-text-field>

        <v-tabs
                slot="extension"
                v-model="tabs"
                centered
                color="transparent"
                slider-color="white"
        >
          <v-tab
                  key="1"
          >
          </v-tab>

          <v-tab key="2" >
          </v-tab>
        </v-tabs>
      </v-toolbar>

      <v-tabs-items v-model="tabs">
        <v-tab-item
                :key="1"
        >

          <v-container  class="teststyle"  grid-list-md text-xs-center
          >

            <v-layout class="participantRow" row wrap v-for="participant in $structuredData.participants" v-if="passesFilter(participant)">

              <v-flex xs12 md3>
                <span class="topTextBottomLabels">{{participant.firstName + ' ' + participant.middleName + ' ' + participant.lastName }}</span>
                <br/>
                <span class="topTextBottomLabels">{{participant.email}}</span>
                <br/>
                <strong class="bottomLabelsNoUnderline">Legal Name</strong>
              </v-flex>
              <v-flex xs4 md2 >
                <span class="topTextBottomLabels">{{participant.GroupsPretty}}</span>
                <br/>
                <strong class="bottomLabelsNoUnderline">Group</strong>

              </v-flex>
              <v-flex xs4 md2>
                <span class="topTextBottomLabels">${{participant.totalFundRaised}}</span>
                <br/>
                <strong class="bottomLabelsNoUnderline">Funds Raised</strong>
              </v-flex>
              <v-flex xs4 md1>
                <span class="topTextBottomLabels">${{participant.totalPaid}}</span>
                <br/>
                <strong class="bottomLabelsNoUnderline">Total Paid</strong>
              </v-flex>
              <v-flex xs5 md1>
                <span class="topTextBottomLabels">${{participant.selectedTripCost}}</span>
                <br/>
                <strong class="bottomLabelsNoUnderline">Trip Cost</strong>
              </v-flex>
              <v-flex xs7 md2>
                <span class="topTextBottomLabels">${{participant.dueAmount}} ({{participant.nextDue | moment("MM-DD-YYYY")}})</span>
                <br/>
                <strong class="bottomLabelsNoUnderline">Next Payment</strong>
              </v-flex>
              <v-flex xs12 md1>
                <v-btn v-if="!participant.disabled" @click="participantToEdit = null; participantToEdit = participant; openDialog = true"  small color="primary">Edit</v-btn>
              <p style="color:red; text-decoration: underline" v-else><b>Disabled</b></p>
              </v-flex>
            </v-layout>


          </v-container>




        </v-tab-item>


        <v-tab-item
                :key="1"
        >
          <h1>test</h1>

        </v-tab-item>


      </v-tabs-items>


    </v-card>



 </section>

</template>

<script lang="js">
    import participantEditForm from '../components/ParticipantInfoDialog'
  export default  {
    name: 'participants',
    props: [],
    mounted() {

    },
    data() {
      return {
          searchField: null,
          selectedResult: null,
          participantToEdit: null,
          openDialog: false

      }
    },
      components: {
          participantEditForm
      },
    methods: {
        passesFilter(participant) {
            if(this.searchField != null && this.searchField.trim().length > 0) {
                if(participant.GroupsPretty.indexOf(this.searchField)  != -1 ||
                    participant.firstName.toLowerCase().indexOf(this.searchField)  != -1 ||
                    participant.lastName.toLowerCase().indexOf(this.searchField) != -1 ||
                    participant.email.indexOf(this.searchField)  != -1 ||
                    (participant.firstName + ' ' + participant.middleName + ' ' + participant.lastName).toLowerCase().indexOf(this.searchField)  != -1) {
                    return true
                } else {
                    return false
                }

            } else {
                return true
            }
        }

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
    .participantRow {
        border-top: 1px solid black;
    }
  .participants {

  }
</style>
